import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PulldownService {
  constructor(private http: HttpClient) {}

  getPdFacility(key: string, inputDate: string): Observable<any> {
    return this.http.get(`${environment.apiUrl}/user/pd-facility`, {params: {key: key, inputDate: inputDate}});
  }
}
